import { Funnel } from "@phosphor-icons/react"
import {
  Button,
  FilterDrawer,
  FormGroup,
  QuerySelector,
} from "@vesatogo/grass-core"
import { DateInput } from "@vesatogo/grass-dates"
import { Dispatch, SetStateAction, useState } from "react"
import {
  useAllCommoditiesQuery,
  useAllVarietiesQuery,
  useTradeStatusesQuery,
  useUsersQuery,
} from "~/generated/graphql"
import { FilterType } from "~/pages/d/trade-requests"

type TripFilterProps = {
  filter: FilterType
  setFilter: Dispatch<SetStateAction<FilterType>>
}
const TripFilter = ({ filter, setFilter }: TripFilterProps) => {
  const [isOpen, setOpen] = useState(false)

  function inputProps(path: string) {
    return {
      value: filter[path],
      onChange: (e: any) => {
        setFilter(prev => ({
          ...prev,
          [path]: e?.target ? e.target.value : e,
        }))
      },
    }
  }

  function getAppliedFilters(prefix: string, filter: any) {
    const totalApplied = Object.keys(filter)?.filter?.(
      key => key.startsWith(prefix) && filter[key]
    )?.length
    return totalApplied ? `${totalApplied} Applied` : null
  }
  return (
    <>
      <Button
        onClick={() => {
          setOpen(prev => !prev)
        }}
        variant="outline"
        className="items-center"
      >
        <Funnel />
      </Button>
      <FilterDrawer
        tabs={[
          {
            id: 1,
            title: "Supplier/Buyer",
            subtitle: getAppliedFilters("sb", filter),
            content: (
              <>
                <FormGroup
                  label="Supplier"
                  className={"mb-2"}
                  helperText="supplier"
                >
                  <QuerySelector
                    serverSideQuery
                    dataHook={useUsersQuery}
                    variables={{ groups: ["Farmer", "Trader"] }}
                    {...inputProps("sb_seller")}
                  />
                </FormGroup>
              </>
            ),
          },
          {
            id: 2,
            title: "Commodity",
            subtitle: getAppliedFilters("com", filter),
            content: (
              <div className="flex flex-col gap-3">
                {" "}
                <FormGroup label="Commodity" className={"w-full"}>
                  <QuerySelector
                    serverSideQuery
                    dataHook={useAllCommoditiesQuery}
                    {...inputProps("com_commodity")}
                  />
                </FormGroup>{" "}
                <FormGroup label="Variety" className={"w-full"}>
                  <QuerySelector
                    dataHook={useAllVarietiesQuery}
                    variables={{ commodity_id: filter.com_commodity?.id }}
                    {...inputProps("com_variety")}
                  />
                </FormGroup>{" "}
              </div>
            ),
          },
          {
            id: 3,
            title: "Others",
            subtitle: getAppliedFilters("oth", filter),
            content: (
              <div className="flex flex-col gap-3">
                <FormGroup label="Status" className={"w-full"}>
                  <QuerySelector
                    // options={TRADE_STATUES}
                    dataHook={useTradeStatusesQuery}
                    getOptionLabel={item => item.id}
                    {...inputProps("oth_status")}
                  />
                </FormGroup>
                <FormGroup label="Created At" className={"w-full"}>
                  <DateInput
                    className={"w-full"}
                    {...inputProps("oth_created_at")}
                  />
                </FormGroup>
              </div>
            ),
          },
        ]}
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        onApply={() => {
          setOpen(false)
        }}
        onClearAll={() => {
          setFilter({})
          setOpen(false)
        }}
      />
    </>
  )
}

export default TripFilter
